import axios from "axios";
import util from "./util";
import config from "../config";

const axiosInstance = axios.create({
    baseURL: config.apiUrl
});

axiosInstance.interceptors.request.use(
    (config) => {
        config.headers.authorization = 'Bearer ' + util.getToken();
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        if (typeof response.data === typeof String()) {
            return { data: response.data, headers: response.headers };
        }
        return { ...response.data, headers: response.headers };
    },
    async (error) => {
        let response = {};

        if (error.response?.code === 401) {
            try {
                const refreshToken = localStorage.getItem("refreshToken");
                const refreshResponse = await axios.post(
                    `${config.apiUrl}/admin/refresh-token`,
                    { refreshToken }
                );

                const newAccessToken = refreshResponse.data?.data?.accessToken;

                if (newAccessToken) {
                    localStorage.setItem("token", newAccessToken);
                    error.config.headers.authorization = 'Bearer ' + newAccessToken;
                    return axios(error.config);
                }

            } catch (refreshError) {

                localStorage.removeItem("token");
                localStorage.removeItem("refreshToken");
                window.location.href = "/login";

                return Promise.reject({ message: "Session expired. Please log in again." });
            }
        }

        if (typeof error.response?.data !== 'undefined') {
            response = error.response?.data;
            if (!response?.message) {
                response.message = error.message;
            }
            if (response.errors && Array.isArray(response.errors)) {
                response.message = response.errors[0].msg;
            }
        } else {
            response.message = error.message;
        }

        return Promise.reject(response);
    }
);

export default axiosInstance;